import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { UserGrant } from '../models/user-grant.js'

const serviceSource = 'droidmap.backend.permissions-service'

export const UserGrantCreated = new BaseEventBuilder<
  UserGrant,
  'User Grant Created'
>(serviceSource, 'User Grant Created')

export const UserGrantDeleted = new BaseEventBuilder<
  UserGrant,
  'User Grant Deleted'
>(serviceSource, 'User Grant Deleted')
